import { render, staticRenderFns } from "./Func51Detalhe.vue?vue&type=template&id=03adc63a"
import script from "./Func51Detalhe.vue?vue&type=script&lang=js"
export * from "./Func51Detalhe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports